export { default } from './load-documents';
